"use client";

import { useState } from "react";
import type { TeamSiteGlueSpecialist } from "~/lib/siteglue/team-siteglue/roster";
import { cn } from "~/lib/utils";

export function TeamPortrait({
  member,
  className,
  size = "card",
}: {
  member: TeamSiteGlueSpecialist;
  className?: string;
  size?: "thumb" | "card" | "hero" | "profile";
}) {
  const [src, setSrc] = useState(member.portraitSrc);
  const [failed, setFailed] = useState(false);
  const initials = member.name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  const frame = cn(
    "relative overflow-hidden bg-slate-100",
    size === "thumb" && "h-16 w-16 rounded-full",
    size === "card" && "aspect-[3/4] w-full rounded-md",
    size === "hero" && "aspect-[3/4] w-full rounded-md",
    size === "profile" && "aspect-[3/4] w-full rounded-md",
    className,
  );

  if (failed) {
    return (
      <div className={cn(frame, "flex items-center justify-center bg-[#4f81bd]/10")} aria-hidden>
        <span className="text-lg font-semibold text-[#4f81bd] sm:text-2xl">{initials}</span>
      </div>
    );
  }

  return (
    <div className={frame}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={src}
        alt={`${member.name}, ${member.title}`}
        className="h-full w-full object-cover object-top"
        onError={() => {
          if (member.portraitFallbackSrc && src !== member.portraitFallbackSrc) {
            setSrc(member.portraitFallbackSrc);
            return;
          }
          setFailed(true);
        }}
      />
    </div>
  );
}
